<template>
  <div class="page-with-top-bar">
    <project-admin-quick-buttons hiddenOption="pictograms"/>
    <section>
      <div class="mt-4">
        <b-tabs type="is-boxed" v-model="mainActiveTab">
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="solar-panel"></b-icon>
              <span> {{ $t('pictograms') }} </span>
            </template>

            <manage-pictograms
              ref="refManagePictograms"
              :projectId="projectId"
              :can-actions-pictogram="canActionsPictogram"
            ></manage-pictograms>
          </b-tab-item>

          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="table-cells"></b-icon>
              <span> {{ $t('photovoltaic_park') }} </span>
            </template>

            <!-- <manage-photovoltaic-park
              ref="refManagePhotovoltaicPark"
              :projectId="projectId"
              :can-actions-pictogram="canActionsPictogram"
            ></manage-photovoltaic-park> -->
          </b-tab-item>

          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="traffic-light"></b-icon>
              <span> {{ $t('manage_statuses') }} </span>
            </template>

            <b-tabs type="is-toggle" expanded>
                <!-- <b-tab-item label="Asignación de estados masivamente" icon="google-photos">
                  <manage-pictogram-statuses
                    ref="managePictogramStatuses"
                    :projectId="projectId"
                    :can-actions-pictogram="canActionsPictogram"
                    @epc-pictograms-reload="_HandlePictogramsRefresh"
                  ></manage-pictogram-statuses>
                </b-tab-item> -->
                <b-tab-item label="Asignación masiva de estados" icon="library-music">
                  <manage-pictogram-statuses-next
                    ref="managePictogramStatusesNext"
                    :projectId="projectId"
                    :can-actions-pictogram="canActionsPictogram"
                    @epc-pictograms-reload="_HandlePictogramsRefresh"
                    :massive="false"
                  ></manage-pictogram-statuses-next>
                </b-tab-item>
            </b-tabs>



          </b-tab-item>

          <!-- TODO: si todo ba bien eliminar este tab -->
          <!-- <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="file-circle-plus"></b-icon>
              <span> {{ $t('add_mechanical_mounting') }} </span>
            </template>

            <manage-pictogram-add
              ref="managePictogramAdd"
              :projectId="projectId"
              :can-actions-pictogram="canActionsPictogram"
              @epc-pictograms-reload="_HandlePictogramsRefresh"
            ></manage-pictogram-add>
          </b-tab-item> -->

          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="grip-lines"></b-icon>
              <span> {{ $t('add_pictogram') }} </span>
            </template>

            <epc-card-grid
              title="Añadir pictograma de instalación mecánica"
              subtitle="Selecciona el tipo de pictograma que deseas crear para esta planta fotovoltaica."
              :items="mechanicalInstallationCategories"
              @item-click="_HandleMechanicalCategoryClick" />
          </b-tab-item>

          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="grip-lines"></b-icon>
              <span> {{ $t('add_evacuation_line') }} </span>
            </template>

            <manage-evacuation-line-add
              ref="manageEvacuationLineAdd"
              :projectId="projectId"
              :can-actions-pictogram="canActionsPictogram"
              @epc-pictograms-reload="_HandlePictogramsRefresh"
            ></manage-evacuation-line-add>
          </b-tab-item>
        </b-tabs>

      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import Form from "vform";
  import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons';
  import ManagePictograms from '../../components/pictograms/manage-pictograms.vue';
  import ManagePictogramAdd from '../../components/pictograms/manage-pictogram-add.vue';
  import ManagePictogramStatuses from '../../components/pictograms/manage-pictogram-statuses.vue';
  import ManagePictogramStatusesNext from '../../components/pictograms/manage-pictogram-statuses-next.vue';
  import ManagePhotovoltaicPark from '../../components/pictograms/manage-photovoltaic-park.vue'
  import ManageEvacuationLineAdd from '../../components/evacuation-line/manage-evacuation-line-add.vue';
  import EpcCardGrid from '../../components/pictograms/shared/components/cards/EpcCardGrid.vue';

  export default {
    middleware: "auth",
    title: "pictograms_drawings_page_title",
    menuOption: "0-2",

    components: {
      ProjectAdminQuickButtons,
      ManagePictograms,
      ManagePictogramStatuses,
      ManagePictogramAdd,ManagePictogramStatusesNext,
      ManagePhotovoltaicPark,
      ManageEvacuationLineAdd,
      EpcCardGrid
    },

    computed: {
      ...mapGetters({
        navData: "app/navData",
        user: "auth/user",
      }),
      projectId() {
        return parseInt(this.navData.project_id);
      }
    },

    data: () => ({
      isLoading: false,
      form: new Form({
        projectId: null,
        partnerId: null,
        companyId: null,
        excelFile: null,
        description: "",
        overwrite: false,
        assignmentType: null,
        activityCode: null,
        actionType: "",
      }),

      entityType: 'project',
      entityId: null,

      errors: [],
      mainActiveTab: 0,
      addDrawings: false,

      canActionsPictogram: {
        'mode_dashboard': false,
        'show_header': true,
        'save': true,
        'select_entity': false
      },

      /**
       * Categorías de la pestaña "Instalación Mecánica".
       * Cada item:
       *   { code, title, description, tag, icon, color, routeType }
       *   - code:      identificador interno
       *   - routeType: valor que se pasa al param `type` de la ruta destino (process-pictogram)
       *   - color:     'blue' | 'amber' | 'red'  (variante del accent + tag)
       */
      mechanicalInstallationCategories: [
        {
          code:        'structures',
          routeType:   'mechanical-installation',
          title:       'Instalación mecánica',
          description: 'Genera el pictograma de mesas, hincados, módulos y paneles a partir del DXF/DWG de implantación de la planta fotovoltaica. Subdivide y prepara las entidades para el seguimiento del avance de montaje.',
          tag:         'Mesas / Hincados / Módulos',
          icon:        'solar-panel',
          color:       'blue',
        },
        {
          code:        'trenches',
          // Debe coincidir con PICTOGRAM_TYPES.DITCHES = 'electrical_trenches'
          // (project-process-pictogram.vue convierte el guión a underscore).
          // Antes era 'excavation-trenches' y por eso el backend no procesaba
          // las capas ni guardaba el .epcb — el match() del controller caía
          // al default por no matchear ninguna de las constantes Pictogram::TYPE_*.
          routeType:   'electrical-trenches',
          title:       'Zanjas de cableado',
          description: 'Pictograma de las zanjas de cableado de baja y media tensión que interconectan strings, cajas combinadoras e inversores. Permite seguir el avance de la obra civil de soterrado.',
          tag:         'Obra civil / Cableado enterrado',
          icon:        'arrows-down-to-line',
          color:       'amber',
        },
        {
          code:        'wiring',
          routeType:   'electrical-installation',
          title:       'Cableado eléctrico',
          description: 'Pictograma del tendido eléctrico del parque: strings, líneas DC/AC, conexiones a inversores y centros de transformación. Sigue el avance de la instalación eléctrica.',
          tag:         'Strings / DC / AC',
          icon:        'bolt',
          color:       'red',
        },
      ],
    }),

    watch: {
      mainActiveTab(value) {
        if (value == 1) {
          // this.$refs.refManagePhotovoltaicPark.FullScreenHack()
          this.redirectToPowerPlant()
        // } else if ( value == 5 ) {
        //   this.redirectToProcessPictogram()
        }
      }
    },

    created() {
      let projectName = this.navData.project_name
        ? this.navData.project_name.toUpperCase()
        : "";
      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];

      this.entityId = this.projectId;
    },

    mounted() {

    },

    beforeDestroy(){
    },

    methods: {
      async getProjectPictograms() {
        this.isLoading = true;
        // Listado admin: modo ligero (no carga capas/estados; no las usa) → mucho más rápido.
        let params = { light: 1 };

        const { data } = await axios.get(
          "/api/v2/project/" + this.entityId + "/pictograms",
          { params: params }
        );

        if (data && data.success) {
          this.pictograms = data.pictograms;
          this.total = data.pictograms ? data.pictograms.length : 0;
        } else {
          this.$notify.error("error_loading_documents");
        }
        this.isLoading = false;
      },

      _HandlePictogramsRefresh() {
        this.$refs.refManagePictograms.RefreshListPictograms()
        this.mainActiveTab = 0
      },

      redirectToPowerPlant() {
        this.$router.push({ name: "project.admin.powerplant", params: {  } });
      },

      /**
       * Click en una de las cards de la pestaña "Instalación Mecánica".
       * Redirige a la página de procesar pictograma pasando el tipo definido
       * en `category.routeType` (declarado junto a cada item del array).
       */
      _HandleMechanicalCategoryClick(category) {
        this.$router.push({
          name:   'project.admin.pictogram.process-create',
          params: { type: category.routeType },
        })
      }
    }
  };
</script>
